import { render, staticRenderFns } from "./OnOffButton.vue?vue&type=template&id=2d126eca&scoped=true"
import script from "./OnOffButton.vue?vue&type=script&lang=js"
export * from "./OnOffButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d126eca",
  null
  
)

export default component.exports